import { WithNAFallback } from '@toggle/design-system';
import { formatPercentage, formatPriceWithCurrency } from '@toggle/helpers';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './TargetItem.styles';

interface TargetItemProps {
  titleKey: string;
  value?: number;
  isNegative: boolean;
  isActive?: boolean;
  changeValue?: number;
  showChange?: boolean;
  currency?: string;
}

export const TargetItem: React.FC<TargetItemProps> = ({
  titleKey,
  value,
  isNegative,
  isActive = false,
  changeValue,
  showChange = false,
  currency,
}) => {
  const { t } = useTranslation(['earnings']);

  return (
    <S.TargetWrapper $isActive={isActive}>
      <S.TargetTitleLabel $isActive={isActive}>
        {t(`earnings:earningsInsight.drawer.earningsPreview.${titleKey}`)}
      </S.TargetTitleLabel>
      {showChange ? (
        <S.AverageTargetWrapper>
          <WithNAFallback
            value={
              <S.TargetValueLabel $isNegative={isNegative} $isActive={isActive}>
                {formatPriceWithCurrency(value ?? 0, currency)}
              </S.TargetValueLabel>
            }
            check={!!value}
            useFallbackDash
          />
          <WithNAFallback
            value={
              <S.AverageTargetChangeLabel $isNegative={(changeValue ?? 0) < 0}>
                {formatPercentage(changeValue ?? 0, {
                  suffix: '%',
                  addPlus: true,
                })}
              </S.AverageTargetChangeLabel>
            }
            check={changeValue !== undefined}
            useFallbackDash
          />
        </S.AverageTargetWrapper>
      ) : (
        <WithNAFallback
          value={
            <S.TargetValueLabel $isNegative={isNegative} $isActive={isActive}>
              {formatPriceWithCurrency(value ?? 0, currency)}
            </S.TargetValueLabel>
          }
          check={!!value}
          useFallbackDash
        />
      )}
    </S.TargetWrapper>
  );
};
